import {defineStore} from "pinia";
import {useAsyncResponse} from "@core/composable/useAsyncCallback.ts";

export default defineStore('LogoutStore', () => {
    return useAsyncResponse();
});
